module.exports = __webpack_public_path__ + "img/Bouton_Eau.7c5a32fb.png";